export default {
  setLoadBtn(state, data) {
    state.loadBtn = data;
  },

  setConfig(state, data) {
    state.config = data;
  },

  setNewsletterDisplay(state, data) {
    state.newsletterDisplay = data;
  },

  setCustomerBanners(state, data) {
    state.customerBanners = data;
  },
  setHonorBanners(state, data) {
    state.honorBanners = data;
  },
  setTeam(state, data) {
    state.team = data;
  },
  setSliders(state, data) {
    state.sliders = data;
  },
  setServices(state, data) {
    state.services = data;
  },
  setServicesById(state, data) {
    state.servicesById = data;
  },

  setTutorials(state, data) {
    state.tutorials = data;
  },
  setTutorialHome(state, data) {
    state.tutorialHome = data;
  },
  setTutorialsPage(state, data) {
    state.tutorialsPage = data;
  },
  setTutorial(state, data) {
    state.tutorial = data;
  },
  setTutorialsPageTotal(state, data) {
    state.tutorialsPageTotal = data;
  },

  setProducts(state, data) {
    state.products = data;
  },
  setProductsHome(state, data) {
    state.productsHome = data;
  },
  setProductsPage(state, data) {
    state.productsPage = data;
  },
  setProduct(state, data) {
    state.product = data;
  },
  setProductsPageTotal(state, data) {
    state.productsPageTotal = data;
  },
  setRelatedProducts(state, data) {
    state.relatedProducts = data;
  },

  setBlogs(state, data) {
    state.blogs = data;
  },
  setRelatedBlogs(state, data) {
    state.relatedBlogs = data;
  },
  setBlogHome(state, data) {
    state.blogHome = data;
  },
  setBlogsPage(state, data) {
    state.blogsPage = data;
  },
  setBlogsPageTotal(state, data) {
    state.blogsPageTotal = data;
  },
  setBlog(state, data) {
    state.blog = data;
  },

  setGalleries(state, data) {
    state.galleries = data;
  },
  setGalleryPage(state, data) {
    state.galleryPage = data;
  },
  setGallery(state, data) {
    state.gallery = data;
  },
  setGalleryList(state, data) {
    state.galleryList = data;
  },
  setGalleryPageTotal(state, data) {
    state.galleryPageTotal = data;
  },

  setCategories(state, data) {
    state.categories = data;
  },

  setCategory(state, data) {
    state.category = data;
  },
  setMenus(state, data) {
    state.menus = data;
  },

  setSocials(state, data) {
    state.socials = data;
  },

  setCities(state, data) {
    state.cities = data;
  },
  setStates(state, data) {
    state.states = data;
  },
  setActivityField(state, data) {
    state.activityField = data;
  },

  setComments(state, data) {
    state.comments = data;
  },
  setCommentsLength(state, data) {
    state.commentsLength = data;
  },

  setPosters(state, data) {
    state.posters = data;
  },

  setDynamicPageContent(state, data) {
    state.dynamicPageContent = data;
  },

  setAboutPage(state, data) {
    state.aboutPage = data;
  },
  setContactPage(state, data) {
    state.contactPage = data;
  },

  setSupport(state, data) {
    state.support = data;
  },

  setRules(state, data) {
    state.rules = data;
  },

  setMethodOfIntroductions(state, data) {
    state.methodOfIntroductions = data;
  },

  setCustomerOpinion(state, data) {
    state.customerOpinion = data;
  },

};
